export default (() => {
  document.addEventListener('DOMContentLoaded', () => {
    window.$odim = window.$odim || {}
    window.$odim.tippy = function (el, options) {
      if (typeof window.tippy === 'undefined') {
        return
      }
      options = options || JSON.parse(el.dataset.tippy || '{}') || {}
      if (Object.keys(options).length > 0) {
        window.tippy(el, options)
      } else {
        window.tippy(el)
      }
    }
    document.querySelectorAll('.js-tippy').forEach((el) => {
      window.$odim.tippy(el)
    })
  })
})()
